import { render, staticRenderFns } from "./matchMcContract.vue?vue&type=template&id=285018d6"
import script from "./matchMcContract.vue?vue&type=script&lang=js"
export * from "./matchMcContract.vue?vue&type=script&lang=js"
import style0 from "./matchMcContract.vue?vue&type=style&index=0&id=285018d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports